import { Colors } from "assets/colors";
import { styles as inputStyles } from "common/inputStyles";

export const styles: any = {
  container: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "30vw",
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: "80vh", 
    minWidth:"70%",
    overflowY: "auto",
    borderRadius: "5px",
    p: 3
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: Colors.GrayText,
    marginBottom: "1rem",
    "& svg": {
      cursor: "pointer"
    }
  },
  subHeader: {
    color: Colors.BlackText,
    fontSize: ".875rem",
    margin: "1.5rem 0 1rem 0"
  },
  subText: {
    color: Colors.BlackText,
    fontSize: ".875rem",
  },
  input: {
    ...inputStyles.inputLight,
    marginBottom: 0,
  },
  textarea: {
    ...inputStyles.inputLight,
    height: "70px",
    width: "100%",
    margin: 0
  },
  inputContainer: {
    paddingTop: ".5rem !important"
  },
  label: {
    fontSize: ".87rem",
    color: Colors.BlueText,
    margin: 0
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "1.5rem 0 0 0"
  },
  cancelButton: {
    ...inputStyles.buttonGreenOutline,
    padding: ".3rem 1.5rem",
    marginRight: ".5rem"
  },
  addButton: {
    ...inputStyles.buttonGreen,
    padding: ".3rem 1.5rem",
  },
  deleteButton: {
    ...inputStyles.buttonOrange,
    padding: ".3rem 1.5rem",
    marginRight: ".5rem"
  },
  subContainer: {
    marginBottom: "1rem"
  },
  Cell: {
    fontSize: ".75rem",
    padding: ".5rem"
  }
}

